module.exports = __webpack_public_path__ + "img/single-product.cd72a1bb.png";